var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "list-group-item align-middle" },
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true },
            },
          ],
          staticClass: "pull-right action-icon",
          attrs: { size: "sm", title: _vm.tooltip },
          on: {
            click: function ($event) {
              return _vm.$emit("actionClicked")
            },
          },
        },
        [
          this.addIcon
            ? _c("span", { staticClass: "fa fa-plus-square" })
            : _vm._e(),
          this.deleteIcon
            ? _c("span", { staticClass: "fa fa-trash-o" })
            : _vm._e(),
        ]
      ),
      _vm.$slots && _vm.$slots.default && !!_vm.$slots.default[0]
        ? _vm._t("default")
        : _c("span", [
            this.href
              ? _c("a", { attrs: { href: _vm.href } }, [
                  _vm._v(_vm._s(_vm.value)),
                ])
              : _c("span", [_vm._v(_vm._s(_vm.value))]),
            _vm._v(" "),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }